/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsList } from "../funcs/toolsetsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolsetsResult } from "../models/components/listtoolsetsresult.js";
import {
  ListToolsetsRequest,
  ListToolsetsSecurity,
} from "../models/operations/listtoolsets.js";
import { unwrapAsync } from "../types/fp.js";
export type ListToolsetsQueryData = ListToolsetsResult;

export function prefetchListToolsets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListToolsetsRequest | undefined,
  security?: ListToolsetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListToolsetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListToolsetsQuery(
  client$: GramCore,
  request?: ListToolsetsRequest | undefined,
  security?: ListToolsetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListToolsetsQueryData>;
} {
  return {
    queryKey: queryKeyListToolsets({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listToolsetsQueryFn(
      ctx,
    ): Promise<ListToolsetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsetsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListToolsets(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "toolsets", "list", parameters];
}
